module.exports = __webpack_public_path__ + "static/media/photo6.94f1b6bc.jpg";